import script from "./czy_zybk.vue?vue&type=script&setup=true&lang=js"
export * from "./czy_zybk.vue?vue&type=script&setup=true&lang=js"

import "./czy_zybk.vue?vue&type=style&index=0&id=e036d604&lang=less"

const __exports__ = script;

export default __exports__